import type { FunctionComponent } from 'react';
import { Text } from '@kanda-libs/ks-design-library';
import { Field, Label } from '@kanda-libs/ks-component-ts';
import { EmploymentDetails } from '@kanda-libs/ks-frontend-services';

import useYearsField from './useYearsField';
import { ERROR_PROPS, MONTHS_OPTIONS } from './constants';

interface YearsFieldProps {
  status: EmploymentDetails['employment_status'];
}

const YearsField: FunctionComponent<YearsFieldProps> = function ({ status }) {
  const { title, names, error, validation, yearsOptions, FieldWidget } =
    useYearsField(status);

  return (
    <div className="flex flex-col w-full text-left">
      <Label label={title} />
      <div className="flex flex-row w-full">
        <div className="w-1/2 mr-4">
          <Field.Select
            options={MONTHS_OPTIONS}
            name={names.months}
            placeholder="Month"
          />
        </div>
        <div className="w-1/2">
          <Field.Select
            options={yearsOptions}
            name={names.years}
            placeholder="Year"
          />
        </div>
      </div>
      {error && <Text text={error} className={ERROR_PROPS.className} />}
      <div className="hidden">
        {FieldWidget && <FieldWidget validation={validation} />}
      </div>
    </div>
  );
};

export default YearsField;
